import React from 'react'
import { Link } from 'react-static'

import { trackedClick } from '../utils'

// import SvgIcon from './SvgIcon'

const AnchorLight = ({ title, href, target, className = 'footer__link' }) => (
    <a
        tabIndex="0"
        className={className}
        onClick={trackedClick('Footer link clicked', {
            source: 'Footer',
            title,
        })}
        href={href}
        title={title}
        target={target}
    >
        {title}
    </a>
)

const Anchor = ({ title, href, target, className }) => (
    <li className="footer__item">
        <AnchorLight
            title={title}
            href={href}
            target={target}
            className={className}
        />
    </li>
)

const TrackedLink = ({ title, href }) => (
    <Link
        tabIndex="0"
        className="footer__link"
        onClick={trackedClick('Footer link clicked', {
            source: 'Footer',
            title,
        })}
        href={href}
        to={href}
        title={title}
    >
        {title}
    </Link>
)

const TrackedLinkItem = ({ title, href }) => (
    <li className="footer__item">
        <TrackedLink href={href} title={title} />
    </li>
)

// TODO fix bootstrap select styles
const Footer = () => (
    <footer className="footer">
        <div className="footer__container container">
            <div className="footer__row footer__row--sections">
                <div className="footer__cols">
                    <div className="footer__col footer__col_with_text">
                        <h5 className="footer__title">
                            Intento makes AI possible
                        </h5>
                        <ul className="footer__list">
                            <li className="footer__item">
                                {`There's been an AI revolution happening over the last ten years. We are enabling enterprises all over the world to benefit from it.`}
                            </li>
                        </ul>
                    </div>
                    <div className="footer__col">
                        <h5 className="footer__title">Company</h5>
                        <ul className="footer__list">
                            <Anchor
                                title="News"
                                href="https://www.facebook.com/intentoco/"
                            />
                            <Anchor
                                title="Blog"
                                href="https://blog.inten.to/"
                            />
                            <Anchor
                                title="Careers"
                                href="https://intento.recruitee.com/"
                                target="_blank"
                            />
                            <Anchor title="Support" href="/support" />
                        </ul>
                    </div>
                    <div className="footer__col">
                        <h5 className="footer__title">AI Service Catalog</h5>
                        <ul className="footer__list">
                            <TrackedLinkItem
                                title="Intent Catalog + Demo"
                                href="/api-platform"
                            />
                            <TrackedLinkItem
                                title="Machine Translation"
                                href="/api-platform/ai/text/translate"
                            />
                            <TrackedLinkItem
                                title="Intent Detection"
                                href="/api-platform/ai/text/detect-intent"
                            />
                            <TrackedLinkItem
                                title="Sentiment Analysis"
                                href="/api-platform/ai/text/sentiment"
                            />
                        </ul>
                    </div>
                    <div className="footer__col">
                        <h5 className="footer__title">Contacts</h5>
                        <ul className="footer__list">
                            <li className="footer__item">
                                2261 Market Street #4273
                                <br />San Francisco, CA 94114
                            </li>
                            <Anchor
                                title="hello@inten.to"
                                href="mailto:hello@inten.to"
                            />
                            <li>
                                <Anchor
                                    tabIndex="0"
                                    onClick={trackedClick(
                                        'Request a demo clicked',
                                        {
                                            source: 'Api catalog footer',
                                            title: 'Request a demo',
                                        }
                                    )}
                                    className="button button--sm button--blue button--send"
                                    href="/mt-demo-request-form-page/"
                                    title="Request a demo"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footer__row footer__row--corp">
                <AnchorLight title="Privacy Policy" href="/privacy" />
                <AnchorLight title="Terms of Service" href="/terms" />
                <span className="footer__copyright">
                    &copy; {new Date().getFullYear()} Intento, Inc. All rights reserved
                </span>
            </div>
        </div>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/Footer.jsx